<div class="w-full mx-auto p-5 space-y-5">

  <!-- ============================================================ -->
  <!-- Header consolidado                                            -->
  <!-- ============================================================ -->
  <div class="flex flex-wrap items-end justify-between gap-4">
    <div>
      <div class="flex items-center gap-2 text-xs font-medium text-slate-500 uppercase tracking-wider">
        <span>Catálogo</span>
        <span class="text-slate-300">/</span>
        <span class="text-slate-700">Proyectos</span>
      </div>
      <h1 class="text-2xl font-semibold text-slate-900 mt-1">Proyectos</h1>
      <p class="text-sm text-slate-500 mt-1 tabular-nums">
        {{ totalRecords }} proyectos · Gestión y seguimiento de proyectos académicos
      </p>
    </div>

    <a routerLink="/projects/new-project" class="btn btn-primary">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
      </svg>
      Nuevo Proyecto
    </a>
  </div>

  <!-- ============================================================ -->
  <!-- KPIs unificados                                               -->
  <!-- ============================================================ -->
  <div class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3">

    <div class="kpi-card kpi-sky">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
        </span>
        Total Proyectos
      </div>
      <div class="kpi-value">{{ totalRecords }}</div>
      <div class="kpi-hint">Catálogo completo</div>
    </div>

    <div class="kpi-card kpi-emerald">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </span>
        Activos
      </div>
      <div class="kpi-value">{{ totalCreated }}</div>
      <div class="kpi-hint tabular-nums">
        {{ totalRecords > 0 ? ((totalCreated / totalRecords) * 100 | number:'1.0-1') : 0 }}% del total
      </div>
    </div>

    <div class="kpi-card kpi-amber">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </span>
        En Pre-Cierre
      </div>
      <div class="kpi-value">{{ totalPreclosed }}</div>
      <div class="kpi-hint">En proceso de cierre</div>
    </div>

    <div class="kpi-card kpi-slate">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
          </svg>
        </span>
        Finalizados
      </div>
      <div class="kpi-value">{{ totalClosed }}</div>
      <div class="kpi-hint">Cerrados</div>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- Toolbar de filtros                                            -->
  <!-- ============================================================ -->
  <div class="filters-toolbar">
    <div class="grid grid-cols-12 gap-3">

      <!-- Buscar -->
      <div class="col-span-12 md:col-span-4">
        <div class="relative">
          <svg class="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input type="text" [(ngModel)]="searchTerm" (input)="onFilterChange()"
            placeholder="Buscar por nombre, código o descripción..."
            class="w-full pl-9 pr-3 h-[38px] border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-slate-400">
        </div>
      </div>

      <!-- ID -->
      <div class="col-span-6 md:col-span-2">
        <input type="number" [(ngModel)]="filterId" (ngModelChange)="onFilterChange()" placeholder="ID #"
          class="w-full px-3 h-[38px] border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-slate-400 tabular-nums">
      </div>

      <!-- Estado -->
      <div class="col-span-6 md:col-span-2">
        <p-dropdown [options]="statusOptions" [(ngModel)]="selectedStatus" (onChange)="onFilterChange()"
          styleClass="w-full" placeholder="Estado" optionLabel="label" optionValue="value" [showClear]="true"
          appendTo="body" panelStyleClass="filter-dropdown-panel" [style]="{'width':'100%'}">
        </p-dropdown>
      </div>

      <!-- Tipo -->
      <div class="col-span-6 md:col-span-2">
        <p-dropdown [options]="typeOptions" [(ngModel)]="selectedType" (onChange)="onFilterChange()"
          styleClass="w-full" placeholder="Tipo" optionLabel="label" optionValue="value" [showClear]="true"
          appendTo="body" panelStyleClass="filter-dropdown-panel" [style]="{'width':'100%'}">
        </p-dropdown>
      </div>

      <!-- Sort + Clear -->
      <div class="col-span-6 md:col-span-2 flex gap-2">
        <button (click)="toggleSortOrder()"
          class="flex-1 h-[38px] px-3 border border-slate-200 rounded-lg bg-white hover:bg-slate-50 flex items-center justify-center gap-1 text-sm text-slate-700 transition-colors"
          [title]="'Ordenar por ID ' + (sortOrder === 'desc' ? 'descendente' : 'ascendente')">
          <svg class="w-4 h-4 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path *ngIf="sortOrder === 'desc'" stroke-linecap="round" stroke-linejoin="round" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4" />
            <path *ngIf="sortOrder === 'asc'" stroke-linecap="round" stroke-linejoin="round" d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12" />
          </svg>
          <span class="tabular-nums">ID</span>
        </button>
        <button (click)="clearFilters()"
          class="flex-shrink-0 h-[38px] px-3 border border-slate-200 rounded-lg bg-white hover:bg-slate-50 flex items-center gap-1 text-sm text-slate-600 transition-colors"
          title="Limpiar todos los filtros">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Fila 2: filtros de fecha -->
      <div class="col-span-12 md:col-span-4">
        <p-dropdown [(ngModel)]="dateType" [options]="dateTypeOptions" (onChange)="onFilterChange()"
          styleClass="w-full" placeholder="Tipo de fecha" optionLabel="label" optionValue="value" appendTo="body"
          panelStyleClass="filter-dropdown-panel" [style]="{'width':'100%'}">
        </p-dropdown>
      </div>

      <div class="col-span-6 md:col-span-4">
        <p-calendar [(ngModel)]="startDate" (onSelect)="onFilterChange()" (onClearClick)="onFilterChange()"
          [showIcon]="true" placeholder="Desde" dateFormat="dd/mm/yy" [showClear]="true" styleClass="w-full"
          appendTo="body" panelStyleClass="filter-datepicker-panel">
        </p-calendar>
      </div>

      <div class="col-span-6 md:col-span-4">
        <p-calendar [(ngModel)]="endDate" (onSelect)="onFilterChange()" (onClearClick)="onFilterChange()"
          [showIcon]="true" placeholder="Hasta" dateFormat="dd/mm/yy" [showClear]="true" styleClass="w-full"
          appendTo="body" panelStyleClass="filter-datepicker-panel">
        </p-calendar>
      </div>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- Loading                                                       -->
  <!-- ============================================================ -->
  <div *ngIf="isLoading" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
    <div *ngFor="let i of [1,2,3,4,5,6]" class="project-skeleton">
      <div class="skeleton-line" style="width: 40px; height: 40px; border-radius: 8px; margin-bottom: 14px;"></div>
      <div class="skeleton-line" style="width: 80%;"></div>
      <div class="skeleton-line" style="width: 60%;"></div>
      <div class="skeleton-line" style="width: 50%; margin-top: 12px;"></div>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- Empty state                                                   -->
  <!-- ============================================================ -->
  <div *ngIf="!isLoading && projects.length === 0"
    class="bg-white border border-dashed border-slate-300 rounded-xl p-10 text-center">
    <div class="mx-auto w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mb-3">
      <svg class="w-6 h-6 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
      </svg>
    </div>
    <p class="text-sm font-medium text-slate-700">
      {{ (searchTerm || filterId || selectedStatus || selectedType || startDate || endDate) ? 'No se encontraron proyectos' : 'No hay proyectos' }}
    </p>
    <p class="text-xs text-slate-500 mt-1">
      {{ (searchTerm || filterId || selectedStatus || selectedType || startDate || endDate) ? 'Intentá con otros filtros' : 'Comenzá creando tu primer proyecto académico.' }}
    </p>
    <a *ngIf="!searchTerm && !filterId && !selectedStatus && !selectedType && !startDate && !endDate"
      routerLink="/projects/new-project" class="btn btn-secondary btn-sm mt-3 inline-flex">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
      </svg>
      Crear primer proyecto
    </a>
  </div>

  <!-- ============================================================ -->
  <!-- Grid de proyectos                                             -->
  <!-- ============================================================ -->
  <div *ngIf="!isLoading && projects.length > 0"
    class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">

    <div *ngFor="let project of projects" class="project-card group">

      <!-- Header -->
      <div class="project-card-header">
        <div class="flex items-start gap-3 min-w-0 flex-1">
          <div class="project-icon">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"
              [attr.d]="null">
              <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="getProjectTypeIcon(project.typeProject)" />
            </svg>
          </div>
          <div class="min-w-0 flex-1">
            <a [routerLink]="['/projects/view-project', project.id]" target="_blank"
              class="inline-flex items-start gap-1.5 group/link min-w-0">
              <h3 class="project-title" [title]="project.name">{{ project.name }}</h3>
              <svg class="w-3 h-3 mt-1 text-slate-400 opacity-0 group-hover/link:opacity-100 transition-opacity flex-shrink-0"
                fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
            <div class="project-meta">
              <span class="project-id-badge">#{{ project.id }}</span>
              <span class="project-code truncate" [title]="project.projectId">{{ project.projectId }}</span>
            </div>
          </div>
        </div>

        <!-- Status pill -->
        <span class="pill flex-shrink-0"
          [ngClass]="{
            'pill-emerald': project.status === 'CREATED',
            'pill-sky':     project.status === 'PRECLOSED',
            'pill-neutral': project.status === 'CLOSED',
            'pill-amber':   project.status === 'INACTIVE',
            'pill-rose':    project.status === 'CANCELED'
          }">
          <span class="w-1.5 h-1.5 rounded-full"
            [ngClass]="{
              'bg-emerald-500': project.status === 'CREATED',
              'bg-sky-500':     project.status === 'PRECLOSED',
              'bg-slate-400':   project.status === 'CLOSED',
              'bg-amber-500':   project.status === 'INACTIVE',
              'bg-rose-500':    project.status === 'CANCELED'
            }"></span>
          {{ getStatusProject(project.status) }}
        </span>
      </div>

      <!-- Info -->
      <div class="space-y-2">
        <div class="project-info-row">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
          </svg>
          <span class="info-label">Tipo:</span>
          <span class="info-value truncate">{{ getProjectTypeName(project.typeProject) }}</span>
        </div>

        <div class="project-info-row">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <span class="info-label">Inicio:</span>
          <span class="info-value tabular">{{ project.date | date:'dd/MM/yy' }}</span>
        </div>

        <div *ngIf="project.dateClosed" class="project-info-row">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
          </svg>
          <span class="info-label">Cierre:</span>
          <span class="info-value tabular">{{ project.dateClosed | date:'dd/MM/yy' }}</span>
        </div>

        <div class="project-info-row">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          <span class="info-label">Participantes:</span>
          <span class="info-value tabular">{{ project.noParticipants || 0 }}</span>
        </div>
      </div>

      <!-- Auditoría -->
      <div class="mt-3">
        <app-audit-info [auditData]="{
            createdBy: project.createdBy,
            createdAt: project.createdAt,
            updatedBy: project.updatedBy,
            updatedAt: project.updatedAt,
            deletedBy: project.deletedBy,
            deletedAt: project.deletedAt,
            isDeleted: project.isDeleted
          }" layout="compact" size="sm">
        </app-audit-info>
      </div>

      <!-- Footer / Acción -->
      <div class="project-footer">
        <a [routerLink]="['/projects/view-project', project.id]" class="btn btn-secondary btn-sm">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          Ver detalles
        </a>
      </div>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- Paginador                                                     -->
  <!-- ============================================================ -->
  <div *ngIf="!isLoading && totalRecords > 0" class="bg-white rounded-xl border border-slate-200">
    <p-paginator [rows]="pageSize" [totalRecords]="totalRecords" [rowsPerPageOptions]="[6, 12, 24, 48]"
      (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando {first}–{last} de {totalRecords}">
    </p-paginator>
  </div>

</div>
